/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FaqContentUpsertRequest } from './FaqContentUpsertRequest';

export type LandingPageFaqCreateRequest = {
    bootCampCategory?: LandingPageFaqCreateRequest.bootCampCategory;
    title?: string;
    sequence?: number;
    contents?: Array<FaqContentUpsertRequest>;
};

export namespace LandingPageFaqCreateRequest {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }


}

